var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sections-list",class:{ 'full-height': _vm.fullHeight }},_vm._l((_vm.sections),function(section,index){return _c(section.__typename,_vm._b({key:_vm.getSectionKey(section, index),tag:"component",staticClass:"module",attrs:{"unique-key":_vm.getSectionKey(section, index),"page-type":_vm.pageType}},'component',{
      sectionData: section,
      config: _vm.config[section.__typename],
      pageName: _vm.pageName
    },false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }